import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const continueButton = css`
  ${breakpoint.down('sm')} {
    width: 100%;
  }

  &:not(:last-child) {
    ${breakpoint.up('md')} {
      margin-right: ${size[16]};
    }

    ${breakpoint.down('sm')} {
      margin-bottom: ${size[16]};
    }
  }
`

export const fullWidth = css`
  margin-right: 0;

  &:not(:last-child) {
    margin-bottom: ${size[16]};
  }
`
